<template lang="pug">
div
  .p-control
    .p-control__title
      h1
        img.p-logo(src='~@/assets/img/kurama_logo2.svg')
      a#download.p-controller__btn.u-margin__right--0.u-margin__left--s(@click='getKML')
        .my-icon.my-icon-icon-kml
      a.p-controller__btn.u-margin__left--s(@click='print')
        .my-icon.my-icon-icon-print
      p.p-login__info ID:{{user}}
      el-button.p-logout(@click='handleLogout') Logout
      a.p-controller__btn.p-toggle.p-close(v-if='controller' @click='close()')
        .my-icon.my-icon-icon-close
      a.p-controller__btn.p-toggle.p-open(v-else @click='open()')
        .my-icon.my-icon-icon-open
    template(v-if='controller')
      el-form(ref='periodForm', :model='datetimeSet', :rules='rules')
        .p-control__list
          h3 計測期間
          span.p-date__label__start 開始
          el-form-item(prop='dateStart')
            el-date-picker(
              v-model='datetimeSet.dateStart'
              :picker-options='pickerMixin_data.datePickerOptionsStart'
              type='date'
              format='yyyy/MM/dd'
              value-format='yyyy-MM-dd'
              :disabled='!isPush'
              placeholder='日付')
          el-form-item(prop='timeStart')
            .p-input__date
              el-time-select(
                v-model='datetimeSet.timeStart'
                :picker-options="pickerMixin_data.pickerOption"
                placeholder='時間'
                @blur='$_utilMixin_blurTimeSelectForStart'
                @change='$_utilMixin_changeTimeSelectForStart'
                :disabled='!isPush')
            span.p-period__end 〜
            span.p-date__label 終了
          el-form-item(prop='dateEnd')
            el-date-picker(
              v-model='datetimeSet.dateEnd'
              :picker-options='pickerMixin_data.datePickerOptionsEnd'
              type='date'
              format='yyyy/MM/dd'
              value-format='yyyy-MM-dd'
              :disabled='!isPush'
              placeholder='日付')
          el-form-item(prop='timeEnd')
            .p-input__date
              el-time-select(
                v-model='datetimeSet.timeEnd'
                :picker-options="pickerMixin_data.pickerOption"
                placeholder='時間'
                @blur='$_utilMixin_blurTimeSelectForEnd'
                @change='$_utilMixin_changeTimeSelectForEnd'
                :disabled='!isPush')

          .p-change__btn__area
            .p-change__btn(@click='isPush = true', v-if='!isPush') 変更
            .p-change__btn.p-change__btn__storage(@click='Storage', v-else='isPush') 保存

      .p-control__list
        h3 背景地図
        span.p-span__label__range 選択
        .p-mesh__select
          input(type='radio', id='MAP1', :value='0', v-model='mapSelect', @change='changeMap', checked)
          label.u-margin__0(for='MAP1') 標準地図
          input(type='radio', id='MAP2', :value='1', v-model='mapSelect', @change='changeMap')
          label(for='MAP2') 航空地図
          input(type='radio', id='MAP3', :value='2', v-model='mapSelect', @change='changeMap')
          label(for='MAP3') OSM

      .p-control__list.-up(v-if='show < 2')
        h3 標準地域
          br
          | メッシュ
        span.p-span__label__range 範囲
        .p-mesh__select
          input(type='radio', id='3', :value='3', v-model='picked', @change='clearData', checked)
          label.u-margin__0(for='3') 基準
            span (1km)
          input(type='radio', id='4', :value='4', v-model='picked', @change='clearData')
          label(for='4') 1/2
            span (500m)
          input(type='radio', id='5', :value='5', v-model='picked', @change='clearData')
          label(for='5') 1/4
            span (250m)
          input(type='radio', id='6', :value='6', v-model='picked', @change='clearData')
          label(for='6') 1/8
            span (125m)
      .p-control__list.-down(v-if='show < 2')
        .p-mesh__select
          input(type='radio', id='7', :value='7', v-model='picked', @change='clearData')
          label.u-margin__0(for='7') 1/16
            span (60m)
          input(type='radio', id='8', :value='8', v-model='picked', @change='clearData')
          label(for='8') 1/32
            span (30m)
          input(type='radio', id='9', :value='9', v-model='picked', @change='clearData')
          label(for='9') 1/128
            span (10m)
          input(type='radio', id='10', :value='10', v-model='picked', @change='clearData')
          label(for='10') 1/1024
            span (1m)

      //- .p-control__list(v-if='show === 2')
        h3 アイコン
          br
          | サイズ
        span.p-span__label__range 範囲
        .p-mesh__select
          input(type='radio', id='icon_size1', :value='0', v-model='radiusSelect', @change='clearData')
          label.u-margin__0(for='icon_size1') 大
          input(type='radio', id='icon_size2', :value='1', v-model='radiusSelect', @change='clearData', checked)
          label(for='icon_size2') 中
          input(type='radio', id='icon_size3', :value='2', v-model='radiusSelect', @change='clearData')
          label(for='icon_size3') 小

      table.c-table
        thead.c-table__head
          tr
            th(width='77', style='padding-left: 10px')
            th.u-padding__left--5(width='42') 表示
            th(width='179') KURAMA ID
            th(width='255') 最新データ取得時間
        tbody.c-table__body
          tr(v-for='(value, index) in devicesData')
            td(class='u-border__0' width='80')
            td.u-padding__left--6(width='40')
              label
                input(type='checkbox', :value='value.kurama_id', v-model='kurama', @change='clearData', class='c-check')
                span(class='c-checkbox')
            td.u-padding__left--4(width='180') {{value.kurama_id}}
            td.u-padding__left--4(width='260')
              p {{value.last_data_taken_at}}

  .p-change
    input(type='radio', id='normal', :value='0', width='76', v-model='show', @change='clearData', checked)
    label.u-margin__0(for='normal') メッシュ
      span.is-pc 表示
    input(type='radio', id='route', :value='2', width='76', v-model='show', @change='clearData')
    label(for='route') 経路
      span.is-pc 表示
  el-form.p-rate__area(ref="meshColorForm" :model='meshDataMixin' :style='{"bottom": rateBottom}')
    .p-rate
      p 空間線量率 (μSv/h)
      .p-color
        template(v-for="(meshData, index) in $_meshDataMixin_getMeshData")
          span(:style="{ backgroundColor: meshData.color }")
      .p-rate__value
        template(v-for="(meshData, index) in $_meshDataMixin_getMeshData")
          el-form-item(
            v-if="index !== ($_meshDataMixin_getMeshData.length - 1)"
            :prop="$_meshDataMixin_getType + '.' + index + '.to'"
            :rules="meshDataMixin.rules.rate"
            )
            el-input(type='text' v-model="meshData.to" :disabled='!isPushRate' @focus='onRateFocus' @blur='onRateFocus')
      .p-change__btn__area
        .p-change__btn(@click='isPushRate = true', v-if='!isPushRate') 変更
        .p-change__btn.p-change__btn__storage(@click="onMeshColor", v-else='isPushRate') 保存
  #map(ref='mapElement',
    v-loading='loading',
    element-loading-text='データ生成中',
    element-loading-spinner='el-icon-loading',
    element-loading-background='rgba(0, 0, 0, 0.8)'
  )
  Popup(ref='popupComponent', :popup='popup', :show='show', @getSpectrumDataChild='getSpectrumData' @getTrendGraphChild='getTrendGraph' @changeId='changeId')
</template>
<script>
import * as util from '@/lib/util';
import L from 'leaflet';
import * as api from '@/api/get';
import * as apiDevices from '@/api/devices';
import * as apiLogout from '@/api/auth/logout';
import mixinUtil from '@/mixin/util';
import mixinMeshData from '@/mixin/meshData';
import mixinPicker from '@/mixin/picker';
import { validateMessage } from '@/lib/validation';
import * as apiLogin from '@/api/auth/is-login';
import Popup from '@/components/Element/Popup';
import imgOwl from '@/assets/img/icon-owl.png';

export default {
  name: 'app',
  mixins: [mixinMeshData, mixinUtil, mixinPicker],
  localStorage: {
    /**
     * 凡例の線量範囲の数値保存用
     * normal[number,]
     * error[number,]
     */
    meshDataRangeObj: {
      type: Object,
      default: {
        normal: [],
        error: [],
      },
    },
  },
  components: {
    Popup,
  },
  data() {
    const validateUtm = (rule, value, callback) => {
      if (value === '') {
        alert(validateMessage.required);
      } else if (!/^\d{2}[A-Z]{3}(\d{8}|\d{10})$/.test(value)) {
        alert(validateMessage.utm);
      } else {
        callback();
      }
    };
    const validateRange = (rule, value, callback) => {
      if (value === '') {
        alert(validateMessage.required);
      } else if (!/^[1-9][0-9]{2,3}$|^10000$/.test(value)) {
        alert(validateMessage.range);
      } else {
        callback();
      }
    };
    const validateColor = (rule, value, callback) => {
      if (value === '') {
        alert('入力は必須です');
      } else {
        callback();
      }
    };
    return {
      loading: false,
      picked: 6,
      icon_size: 1,
      controller: true,
      checked: null,
      n: null,
      /**
       * 描画したメッシュ objectを格納
       * @returns {array}
       */
      mesh: [],
      mymap: null,
      datetime: {
        dateStart: null,
        dateEnd: null,
        timeStart: null,
        timeEnd: null,
        comment: '',
      },
      datetimeSet: {
        dateStart: null,
        dateEnd: null,
        timeStart: null,
        timeEnd: null,
        comment: '',
      },
      chartVisible: false,
      /**
       * 地図(メッシュ)表示状態確認用
       * 0 : 通常メッシュ, 1 : 誤差メッシュ, 2 : 経路表示
       * @returns {number}
       */
      show: 0,
      devicesData: [],
      name: '',
      id: '',
      isPush: false,
      /**
       * 線量数値入力欄のdisabled制御用
       * @returns {Boolean}
       */
      isPushRate: false,
      disabled: false,
      rules: {
        range: [{ validator: validateRange, trigger: 'blur' }],
        utm_point: [{ validator: validateUtm, trigger: 'blur' }],
        rate: [{ validator: validateColor, trigger: 'blur' }],
      },
      /**
       * 各apiを切り替えたものをいれる
       * @returns {undefined|Object}
       */
      number: null,
      radius: null,
      radiusSelect: 0,
      first: true,
      select: null,
      unusable: [],
      zoom: 14,
      add: false,
      dataLength: null,
      now: null,
      timerID: null,
      chachTime: 1000,
      /**
       * データ取得時にデータがない場合に表示するアラート制御用
       * true : アラート表示
       * false: アラート非表示
       * @returns {boolean}
       */
      dataAlertDisplayFlg: true,
      graph: {
        loaded: false,
        chartDate: null,
      },
      kurama: [],
      defaultMap: [],
      airMap: [],
      mapSelect: 0,
      user: null,
      circleSize: 10,
      iconSize: 20,
      popup: {
        date: null,
        der: null,
        devices: null,
        id: null,
        lat: null,
        lng: null,
        mesh: null,
        mesh_code: null,
        kurama_id: null,
        n_data: null,
      },
      marker: null,
      icon: null,
      lead: null,
      changekuramaID: null,
      rateBottom: '20px',
    };
  },
  methods: {
    init() {
      this.defaultDate();
      this.getDevices();
      this.getLoginUser();
      this.$_meshDataMixin_initData();
    },
    open() {
      this.controller = true;
    },
    close() {
      this.controller = false;
    },
    defaultDate() {
      this.now = new Date();
      const date = util.formatDate(this.now, 'YYYY-MM-DD');
      this.datetime.dateStart = date;
      this.datetime.dateEnd = date;
      this.datetime.timeStart = '00:00';
      this.datetime.timeEnd = '23:59';
      this.datetimeSet.dateStart = date;
      this.datetimeSet.dateEnd = date;
      this.datetimeSet.timeStart = '00:00';
      this.datetimeSet.timeEnd = '23:59';
    },
    getData() {
      if (this.kurama.length === 0) {
        window.clearTimeout(this.timerID);
        if (this.chachTime > 0) {
          this.timerID = setTimeout(this.getData, this.chachTime);
        }
        this.loading = false;
        return false;
      }
      let id = this.picked;
      let view;
      if (this.show === 2) {
        view = 'route';
        id = '';
      } else {
        view = 'mesh';
      }
      let params = {
        from: this.datetime.dateStart + ' ' + this.datetime.timeStart,
        to: this.datetime.dateEnd + ' ' + this.datetime.timeEnd,
        n: this.n,
        view: view,
        kurama: this.kurama,
      };
      api
        .get(id, params)
        .then((res) => {
          this.chachTime = res.data.rtime;
          let data = res.data.data;
          if (data.length === 0 && !res.data.n) {
            this.loading = false;
            this.dataLength = false;
            /**
             * データがない状態が続く限り一度しかアラートは表示しない
             */
            if (this.dataAlertDisplayFlg) {
              alert('表示するデータがありません');
              this.dataAlertDisplayFlg = false;
            }
            this.dataAlertDisplayFlg = false;
            window.clearTimeout(this.timerID);
            if (this.chachTime > 0) {
              this.timerID = setTimeout(this.getData, this.chachTime);
            }
            return false;
          } else {
            // データ取得できたのでフラグ戻す
            this.dataAlertDisplayFlg = true;
            this.dataLength = true;
          }
          let sq = null;
          // 最新計測地点データ
          let myzoom = {
            start: this.mymap.getZoom(),
            end: this.mymap.getZoom(),
          };
          if (this.show === 2) {
            this.setZoom(myzoom);
          }
          this.mymap.on('zoomstart', function (e) {
            myzoom.start = e.target._zoom;
          });
          let setThis = this;
          this.mymap.on('zoomend', function (e) {
            myzoom.end = e.target._zoom;
            if (setThis.show === 2) {
              setThis.setZoom(myzoom);
              Object.keys(e.target._layers).forEach((key) => {
                e.target._layers[key]._mRadius = setThis.circleSize;
              });
            }
          });
          data.forEach((val) => {
            /**
             * APIから取得したデータ内にmesh[]と同じmesh_codeのデータ存在した場合は
             * 前のメッシュを削除する
             * 経路表示のAPIを叩いているかそれともマップメッシュ表示のAPIを叩いているかの条件分岐
             * 経路の時は重複メッシュを削除する必要がない
             */
            if (this.show !== 2) {
              this.mesh.forEach((v, i) => {
                if (v.val.mesh_code === val.mesh_code) {
                  this.mesh[i].sq.remove();
                  this.mesh.splice(i, 1);
                }
              });
            }
            const der = this.$_meshDataMixin_getType === 'normal' ? val.der : val.error_ratio;
            const colorHex = this.$_meshDataMixin_getMeshColorByDer(der);
            if (this.show === 2) {
              let lastpos = [val.lat, val.lng];
              sq = L.circleMarker(lastpos, {
                radius: 5,
                weight: 0,
                fillColor: colorHex,
                fillOpacity: 0.5,
              }).addTo(this.mymap);
              // sq = L.circle(lastpos, { color: colorHex, stroke: false, weight: 0, fillOpacity: 0.6 }).addTo(this.mymap)
              sq.setRadius(this.circleSize);
            } else {
              sq = L.rectangle(val.mesh, {
                color: colorHex,
                stroke: false,
                weight: 0,
                fillOpacity: 0.6,
                kurama: val.devices,
              }).addTo(this.mymap);
            }
            /**
             * メッシュ用のポップアップデータ挿入
             */
            let popupData = this.$data.popup;
            sq.on('click', onClick);
            function onClick() {
              popupData.date = val.date;
              popupData.der = val.der;
              popupData.devices = val.devices;
              popupData.lat = val.lat;
              popupData.lng = val.lng;
              popupData.mesh_code = val.mesh_code;
              popupData.n_data = val.n_data;
              popupData.kurama_id = val.kurama_id;
              const beforekuramaID = setThis.changekuramaID;
              if (popupData.devices) {
                if (popupData.devices.length === 1) {
                  popupData.kuramaID = popupData.devices[0];
                } else {
                  if (popupData.devices.some((item) => item === beforekuramaID)) {
                    popupData.kuramaID = beforekuramaID;
                  } else {
                    popupData.kuramaID = null;
                  }
                }
              }
              setThis.changekuramaID = popupData.kuramaID;
            }
            /**
             * メッシュと経路ごとにポップアップ生成
             */
            this.popup = popupData;
            sq.bindPopup(this.$refs.popupComponent.$el);
            const data = {
              val: val,
              sq: sq,
            };
            if (this.dataLength) {
              this.n = res.data.n;
            }
            this.setMeshCode(data);
            /**
             * イテレーターが最後まで回ったら最後のメッシュにズームするでいいのいか？？
             */
            if (this.mesh.length === res.data.data.length && this.show === 2) {
              this.mymap.setView([val.lat, val.lng]);
            } else if (this.mesh.length === res.data.data.length) {
              this.mymap.setView([
                (val.mesh[0][0] + val.mesh[1][0]) / 2,
                (val.mesh[0][1] + val.mesh[1][1]) / 2,
              ]);
            }
            this.loading = false;
          });
          if (this.show === 2) {
            this.marker.addTo(this.mymap);
            this.marker.bindPopup(this.$refs.popupComponent.$el);
            this.lead = this.mesh[this.mesh.length - 1];
            this.marker.setLatLng([this.lead.sq._latlng.lat, this.lead.sq._latlng.lng]);
            this.setIconSize();
            let setThis = this;
            this.mymap.on('zoomend', function () {
              setThis.setIconSize();
            });
          } else {
            this.mymap.removeLayer(this.marker);
          }
          window.clearTimeout(this.timerID);
          if (this.chachTime > 0) {
            this.timerID = setTimeout(this.getData, this.chachTime);
          }
        })
        .catch(() => {
          this.loading = false;
          window.clearTimeout(this.timerID);
          if (this.chachTime > 0) {
            this.timerID = setTimeout(this.getData, this.chachTime);
          }
        });
    },
    setZoom(myzoom) {
      /**
       * 経路メッシュ取得時に自動でメッシュの大きさを現在のズームレベルで設定されているメッシュの大きさに変える処理
       */
      if (this.radiusSelect === 0) {
        this.circleSize = 10;

        if (myzoom.end === 21) {
          this.iconSize = 250;
        } else if (myzoom.end === 20) {
          this.iconSize = 200;
        } else if (myzoom.end === 19) {
          this.iconSize = 150;
        } else if (myzoom.end === 18) {
          this.iconSize = 100;
        } else if (myzoom.end === 17) {
          this.iconSize = 50;
        } else if (myzoom.end === 16) {
          this.iconSize = 40;
        } else if (myzoom.end === 15 || myzoom.end === 14) {
          this.iconSize = 25;
        } else if (myzoom.end === 13 || myzoom.end === 12 || myzoom.end === 11) {
          this.iconSize = 30;
        } else if (myzoom.end === 10 || myzoom.end === 9 || myzoom.end === 8) {
          this.iconSize = 25;
        } else {
          this.iconSize = 30;
        }
      } else if (this.radiusSelect === 1) {
        this.circleSize = 5;

        if (myzoom.end === 21) {
          this.iconSize = 200;
        } else if (myzoom.end === 20) {
          this.iconSize = 120;
        } else if (myzoom.end === 19) {
          this.iconSize = 75;
        } else if (myzoom.end === 18) {
          this.iconSize = 45;
        } else if (myzoom.end === 17) {
          this.iconSize = 30;
        } else if (myzoom.end === 16) {
          this.iconSize = 30;
        } else if (myzoom.end === 15 || myzoom.end === 14) {
          this.iconSize = 25;
        } else if (myzoom.end === 13 || myzoom.end === 12 || myzoom.end === 11) {
          this.iconSize = 30;
        } else if (myzoom.end === 10 || myzoom.end === 9 || myzoom.end === 8) {
          this.iconSize = 25;
        } else {
          this.iconSize = 30;
        }
      } else if (this.radiusSelect === 2) {
        this.circleSize = 3;

        if (myzoom.end === 21) {
          this.iconSize = 50;
        } else if (myzoom.end === 20) {
          this.iconSize = 50;
        } else if (myzoom.end === 19) {
          this.iconSize = 40;
        } else if (myzoom.end === 18) {
          this.iconSize = 30;
        } else if (myzoom.end === 17) {
          this.iconSize = 25;
        } else if (myzoom.end === 16) {
          this.iconSize = 25;
        } else if (myzoom.end === 15 || myzoom.end === 14) {
          this.iconSize = 25;
        } else if (myzoom.end === 13 || myzoom.end === 12 || myzoom.end === 11) {
          this.iconSize = 30;
        } else if (myzoom.end === 10 || myzoom.end === 9 || myzoom.end === 8) {
          this.iconSize = 25;
        } else {
          this.iconSize = 30;
        }
      }
    },
    /**
     * 表示中のメッシュ管理用データに新たなデータを追加する処理
     * @param {object} meshData - メッシュデータ
     */
    setMeshCode(meshData) {
      this.mesh = this.mesh.concat(meshData);
    },
    /**
     * 測定車情報を取得する
     */
    getDevices() {
      apiDevices
        .get()
        .then((res) => {
          if (this.first === true) {
            this.first = false;
            this.devicesData = res.data.devices;
          } else {
            this.devicesData = res.data.devices;
          }
          this.number = res.data.devices.length;
          this.devicesData = res.data.devices;
          setTimeout(this.getDevices, 30000);
        })
        .catch(() => {
          setTimeout(this.getDevices, 30000);
        });
    },
    /**
     * mesh管理用のデータを初期化
     */
    clearMesh() {
      this.mesh = [];
    },
    /**
     * KMLデータをダウンロード
     * @returns {undefined}
     */
    getKML() {
      const view = this.show === 2 ? 'route' : 'mesh';
      const from = this.datetime.dateStart + '+' + this.datetime.timeStart;
      const to = this.datetime.dateEnd + '+' + this.datetime.timeEnd;
      let kurama = '';
      this.kurama.forEach((el) => {
        kurama = kurama + 'kurama[]=' + el + '&';
      });
      const url =
        '/api/download-kml/?' +
        kurama +
        'view=' +
        view +
        '&mesh=' +
        this.picked +
        '&from=' +
        from +
        '&to=' +
        to;
      window.open(url);
    },
    /**
     * スペクトラムデータをDL
     * @param {number} meshCode - 該当メッシュコード
     */
    getSpectrumData(meshCode) {
      let el = document.getElementById('p-sel');
      let devices = el.value;
      let from = this.datetime.dateStart + '+' + this.datetime.timeStart;
      let to = this.datetime.dateEnd + '+' + this.datetime.timeEnd;
      let url =
        '/view-spectrum?kurama=' + devices + '&mesh=' + meshCode + '&from=' + from + '&to=' + to;
      window.open(url);
    },
    /**
     * トレンドグラフ
     */
    getTrendGraph(meshCode) {
      let el = document.getElementById('p-sel');
      let devices = el.value;
      let from = this.datetime.dateStart + '+' + this.datetime.timeStart;
      let to = this.datetime.dateEnd + '+' + this.datetime.timeEnd;
      let url =
        '/view-trend?kurama=' + devices + '&mesh=' + meshCode + '&from=' + from + '&to=' + to;
      window.open(url);
    },
    changeId(id) {
      this.changekuramaID = id;
    },
    /**
     * 表示タイプの切り替わりのタイミングでデータをクリアする
     */
    clearData() {
      /**
       * 切り替わったらloadingを表示する
       * 切り替えるのは次のAPI取得タイミングに移譲
       */
      window.clearTimeout(this.timerID);
      this.loading = true;
      this.n = null;
      if (this.mesh) {
        this.mesh.forEach((val) => {
          val.sq.remove();
          this.dataLength = false;
        });
      }
      /**
       * 表示対応が切り替わったのでmeshを初期化する
       */
      if (this.kurama.length === 0) {
        this.loading = false;
        // alert('測定車が一つも選択されていないのでデータがありません')
      }
      this.clearMesh();
      if (!this.dataLength) {
        this.getData();
      }
    },
    /**
     * 線量範囲の値を保存
     */
    onMeshColor() {
      this.$refs.meshColorForm.validate((valid) => {
        if (valid) {
          this.isPushRate = false;
          this.changeMeshColor();
          this.$_meshDataMixin_setData();
        } else {
          return false;
        }
      });
    },
    /**
     * メッシュのカラーを線量範囲の数値をもとに再設定
     */
    changeMeshColor() {
      this.mesh.forEach((mesh) => {
        let colorHex = null;
        if (this.$_meshDataMixin_getType === 'normal') {
          colorHex = this.$_meshDataMixin_getMeshColorByDer(mesh.val.der);
        } else {
          colorHex = this.$_meshDataMixin_getMeshColorByDer(mesh.val.error_ratio);
        }
        mesh.sq.setStyle({ color: colorHex });
      });
    },
    drawingChart() {
      this.graph.loaded = false;
    },
    /**
     * 航空写真と標準地図の切り替え
     */
    changeMap() {
      switch (this.mapSelect) {
        case 0:
          this.mymap.removeLayer(this.airMap);
          this.mymap.removeLayer(this.openStreetMap);
          this.defaultMap.addTo(this.mymap);
          break;
        case 1:
          this.mymap.removeLayer(this.defaultMap);
          this.mymap.removeLayer(this.openStreetMap);
          this.airMap.addTo(this.mymap);
          break;
        case 2:
          this.mymap.removeLayer(this.defaultMap);
          this.mymap.removeLayer(this.airMap);
          this.openStreetMap.addTo(this.mymap);
          break;
        default:
          break;
      }
    },
    /**
     * 変更した日時をセットする
     */
    Storage() {
      this.$refs.periodForm.validate((valid) => {
        if (valid) {
          this.isPush = false;
          this.datetime.dateStart = this.datetimeSet.dateStart;
          this.datetime.dateEnd = this.datetimeSet.dateEnd;
          this.datetime.timeStart = this.datetimeSet.timeStart;
          this.datetime.timeEnd = this.datetimeSet.timeEnd;
          this.clearData();
        } else {
          return false;
        }
      });
    },
    print() {
      window.print();
    },
    handleLogout() {
      apiLogout
        .post()
        .then(() => {
          this.$router.push({ path: '/login' });
          console.log('success');
        })
        .catch(() => {
          console.log('error');
        });
    },
    getLoginUser() {
      apiLogin
        .get()
        .then((res) => {
          this.user = res.data.account.name;
        })
        .catch(() => {
          console.log('error');
        });
    },
    setIconSize() {
      this.icon = L.icon({
        iconUrl: imgOwl,
        iconRetinaUrl: imgOwl,
        iconSize: [this.iconSize, this.iconSize],
      });
      this.marker.setIcon(this.icon);
    },
    /**
     * iPadで空間線量率の枠が隠れないように調整
     */
    onRateFocus(val) {
      if (navigator.userAgent.match(/iPad/)) {
        this.rateBottom = val.type === 'focus' ? '80px' : '20px';
      }
    },
  },
  mounted() {
    this.mymap = L.map(this.$refs['mapElement'], {
      preferCanvas: true,
    }).setView([34.3880234, 135.3466352], this.zoom);
    this.defaultMap = L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
      attribution:
        "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>",
      maxZoom: 21,
      maxNativeZoom: 18,
      minZoom: 7,
      id: 'ku',
    });
    this.airMap = L.tileLayer(
      'https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg',
      {
        attribution:
          "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>",
        maxZoom: 21,
        maxNativeZoom: 18,
        minZoom: 7,
        id: 'ku',
      }
    );
    this.openStreetMap = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: "<a href='https://openstreetmap.jp/' target='_blank'>© OpenStreetMap</a>",
      maxZoom: 19,
      maxNativeZoom: 18,
      minZoom: 7,
      id: 'ku',
    });
    this.defaultMap.addTo(this.mymap);
    if (this.show === 2) {
      this.icon = L.icon({
        iconUrl: imgOwl,
        iconRetinaUrl: imgOwl,
        iconSize: [this.iconSize, this.iconSize],
      });
      this.marker = L.marker([34.3880234, 135.3466352], { icon: this.icon });
    }
  },
  created() {
    this.init();
  },
};
</script>
